import { render, staticRenderFns } from "./ArtPerfStudents.vue?vue&type=template&id=6ec31f5c&"
import script from "./ArtPerfStudents.vue?vue&type=script&lang=ts&"
export * from "./ArtPerfStudents.vue?vue&type=script&lang=ts&"
import style0 from "./ArtPerfStudents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports